import { useState, useEffect } from "react";
import clsx from "clsx";
import warning from "../../images/icons/warning.svg";
import closepopup from "../../images/icons/closepopup.svg";

const DeleteModal = ({ title, isOpen, onConfirm, onCancel }) => {
    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setIsAnimating(true);
        }
    }, [isOpen]);

    const handleCancel = () => {
        setIsAnimating(false);
        setTimeout(() => {
            onCancel();
        }, 200);
    };

    const handleConfirm = () => {
        setIsAnimating(false);
        setTimeout(() => {
            onConfirm();
        }, 200);
    };

    if (!isOpen && !isAnimating) return null;

    return (
        <div
            className={clsx(
                "fixed inset-0 bg-black/50 flex items-center justify-center z-50 transition-opacity duration-200",
                isAnimating ? "opacity-100" : "opacity-0 pointer-events-none"
            )}
            onClick={handleCancel}
        >
            <div
                className={clsx(
                    "bg-white rounded-2xl shadow-lg w-full max-w-[580px] h-[210px] transition-transform duration-200 flex flex-col",
                    isAnimating ? "scale-100" : "scale-95"
                )}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <div className="flex justify-between items-center px-6 py-4 border-b border-[#EEF0F2] gap-2.5">
                    <h2 className="text-lg font-semibold text-gray-900 flex-1">
                        Delete Scheduled Task
                    </h2>
                    <button
                        onClick={handleCancel}
                        className="text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0 flex items-center justify-center"
                        aria-label="Close"
                    >
                        <img src={closepopup} />
                    </button>
                </div>

                {/* Content */}
                <div className="flex gap-3 px-6 py-7 flex-1">
                    <div className="flex-shrink-0">
                        <img src={warning} alt="Warning icon" />
                    </div>
                    <div className="flex-1">
                        <p className="text-gray-700 text-sm leading-relaxed px-2 py-0.5">
                            This will permanently delete this scheduled task and its history.
                        </p>
                    </div>
                </div>

                {/* Footer */}
                <div className="flex gap-3 justify-end px-6 py-4">
                    <button
                        onClick={handleCancel}
                        className="py-2 px-6 border border-gray-300 rounded-xl text-gray-700 font-medium hover:bg-gray-50 transition-colors text-sm"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleConfirm}
                        className="py-2 px-6 bg-gray-900 text-white font-medium rounded-xl hover:bg-gray-800 transition-colors text-sm"
                    >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteModal;